/* ==========================================================================
   ARTEECA WORLD — Judge.me : lisibilité + avis en rangée horizontale
   1) Le widget Judge.me affiche du texte noir par défaut : sur le fond noir de la boutique il est
      illisible. Ce script repère tout texte trop sombre posé sur un fond sombre et le passe en
      blanc lune (#ddd7c8). Il ne touche pas aux pastilles claires (ex. « Verified » turquoise).
   2) Il repère la liste des avis et la marque (data-ar-jm-list / data-ar-jm-card) pour que
      judgeme-arteeca.css l'affiche en rangée horizontale (cartes côte à côte, défilement latéral).
   Indépendant des noms de classes exacts du widget : il fonctionne aussi après une mise à jour.
   ========================================================================== */
(function () {
  'use strict';

  var LIGHT = '#ddd7c8';
  var ROOTS = '#judgeme_product_reviews, .jdgm-widget, [class*="jdgm-"], [class*="jm-"]';
  var SKIP = { SCRIPT: 1, STYLE: 1, IMG: 1, VIDEO: 1, CANVAS: 1, NOSCRIPT: 1, IFRAME: 1 };
  var MIN_CONTRAST = 3.5;
  var STAR = '.jm-star-rating__font-icon, [class*="jm-star-rating"], .jdgm-star, [class*="jdgm-star"]';
  var DATE = /^(?:\d+\s+(?:seconds?|minutes?|hours?|days?|weeks?|months?|years?)\s+ago|il y a\s+\d+\s+\S+|\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{2,4}|\d{4}[\/.\-]\d{1,2}[\/.\-]\d{1,2}|[A-Za-zÀ-ÿ]{3,9}\.?\s+\d{1,2},?\s+\d{4}|\d{1,2}\s+[A-Za-zÀ-ÿ]{3,9}\.?\s+\d{4})$/;
  var MARK = STAR + ', [data-ar-jm-date]';
  var timer = null;
  var runId = 0;

  /* ---------- couleurs ---------- */
  function parse(c) {
    var m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+%?))?\s*\)/.exec(c || '');
    if (!m) return null;
    var a = m[4] === undefined ? 1 : m[4].slice(-1) === '%' ? parseFloat(m[4]) / 100 : parseFloat(m[4]);
    return { r: +m[1], g: +m[2], b: +m[3], a: a };
  }

  function lum(c) {
    function ch(v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * ch(c.r) + 0.7152 * ch(c.g) + 0.0722 * ch(c.b);
  }

  function contrast(l1, l2) {
    var hi = Math.max(l1, l2);
    var lo = Math.min(l1, l2);
    return (hi + 0.05) / (lo + 0.05);
  }

  /* Fond réellement visible derrière l'élément (on remonte jusqu'au premier fond opaque). */
  function backdrop(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var cs = window.getComputedStyle(node);
      var bg = parse(cs.backgroundColor);
      if (bg && bg.a > 0.5) return bg;
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null; /* image : on ne décide pas */
      node = node.parentElement;
    }
    var page = parse(window.getComputedStyle(document.body).backgroundColor);
    return page && page.a > 0.5 ? page : { r: 0, g: 0, b: 0, a: 1 };
  }

  function fix(el) {
    if (SKIP[el.tagName] || el.closest('svg') && el.tagName.toLowerCase() !== 'svg') return;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return;
    var fg = parse(cs.color);
    if (!fg || fg.a < 0.2) return;
    var bg = backdrop(el);
    if (!bg) return;
    var bgL = lum(bg);
    if (bgL > 0.25) return; /* fond clair : le texte sombre est lisible, on ne touche pas */
    if (contrast(lum(fg), bgL) >= MIN_CONTRAST) return;
    el.style.setProperty('color', LIGHT, 'important');
  }

  /* ---------- éléments des widgets Judge.me (sans doublons) ---------- */
  function collect() {
    var roots = document.querySelectorAll(ROOTS);
    var out = [];
    var stamp = ++runId;
    for (var i = 0; i < roots.length; i++) {
      var nodes = [roots[i]];
      var list = roots[i].querySelectorAll('*');
      for (var j = 0; j < list.length; j++) nodes.push(list[j]);
      for (var k = 0; k < nodes.length; k++) {
        if (nodes[k].__arJm === stamp) continue;
        nodes[k].__arJm = stamp;
        out.push(nodes[k]);
      }
    }
    return out;
  }

  /* ---------- liste des avis ---------- */
  function sameKind(a, b) {
    return a.tagName === b.tagName && (a.classList[0] || '') === (b.classList[0] || '');
  }

  function textLen(el) {
    return (el.textContent || '').trim().length;
  }

  /* Repère les dates (feuilles « 26/03/2026 », « Oct 10, 2026 »…) : un avis en contient une. */
  function markDates(all) {
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length || SKIP[el.tagName] || el.closest('svg')) continue;
      var t = (el.textContent || '').trim();
      if (t.length >= 6 && t.length <= 20 && DATE.test(t)) el.setAttribute('data-ar-jm-date', '');
    }
  }

  /* Pour chaque étoile / date : on remonte jusqu'au plus petit parent dont au moins 2 enfants
     « du même type » contiennent chacun un repère (= la liste d'avis et ses cartes). */
  function findLists(all, strict) {
    var found = [];
    for (var i = 0; i < all.length; i++) {
      var seed = all[i];
      if (!seed.matches(MARK) || SKIP[seed.tagName]) continue;
      var a = seed;
      while (a.parentElement && a.parentElement !== document.body) {
        var p = a.parentElement;
        var sibs = [];
        for (var k = 0; k < p.children.length; k++) {
          if (sameKind(p.children[k], a)) sibs.push(p.children[k]);
        }
        var ok = sibs.length >= 2 && sibs.length <= 60;
        for (var m = 0; ok && m < sibs.length; m++) {
          var card = sibs[m];
          var good = strict ? card.querySelector(STAR) && card.querySelector('[data-ar-jm-date]') : card.querySelector(MARK);
          if (!good || textLen(card) < 25) ok = false;
        }
        if (ok) {
          var dup = false;
          for (var f = 0; f < found.length; f++) if (found[f].list === p) dup = true;
          if (!dup) found.push({ list: p, cards: sibs });
          break;
        }
        a = p;
      }
    }
    /* on garde la liste la plus profonde (jamais un conteneur qui en contient une autre) */
    return found.filter(function (x) {
      for (var f = 0; f < found.length; f++) {
        if (found[f].list !== x.list && x.list.contains(found[f].list)) return false;
      }
      return true;
    });
  }

  /* Secours : avis « à plat » (pas d'enveloppe par avis) -> on enveloppe chaque avis dans un <div>. */
  function wrapFlat(all) {
    var dates = [];
    for (var i = 0; i < all.length; i++) if (all[i].hasAttribute('data-ar-jm-date')) dates.push(all[i]);
    if (dates.length < 2) return false;
    var c = dates[0].parentElement;
    while (c && c !== document.body) {
      var inside = 0;
      for (var d = 0; d < dates.length; d++) if (c.contains(dates[d])) inside++;
      if (inside === dates.length) break;
      c = c.parentElement;
    }
    if (!c || c === document.body || c.children.length > 120) return false;
    var kids = Array.prototype.slice.call(c.children);
    var groups = [];
    var cur = null;
    kids.forEach(function (k) {
      if (k.querySelector(STAR) || k.matches(STAR)) {
        cur = [];
        groups.push(cur);
      }
      if (cur) cur.push(k);
    });
    groups = groups.filter(function (g) {
      return g.some(function (k) { return k.hasAttribute('data-ar-jm-date') || k.querySelector('[data-ar-jm-date]'); });
    });
    if (groups.length < 2) return false;
    groups.forEach(function (g) {
      var w = document.createElement('div');
      w.className = 'ar-jm-review';
      g[0].parentNode.insertBefore(w, g[0]);
      g.forEach(function (k) { w.appendChild(k); });
    });
    return true;
  }

  function markReviewList(all) {
    markDates(all);
    var withDates = document.querySelectorAll('[data-ar-jm-date]').length >= 2;
    /* 1) cartes contenant étoiles + date ; 2) avis « à plat » qu'on enveloppe ; 3) sans date : étoiles seules */
    var lists = findLists(all, true);
    if (!lists.length && withDates && wrapFlat(all)) lists = findLists(collect(), true);
    if (!lists.length && !withDates) lists = findLists(all, false);
    for (var i = 0; i < lists.length; i++) {
      lists[i].list.setAttribute('data-ar-jm-list', '');
      for (var k = 0; k < lists[i].cards.length; k++) lists[i].cards[k].setAttribute('data-ar-jm-card', '');
    }
  }

  /* ---------- exécution ---------- */
  function run() {
    timer = null;
    var all = collect();
    markReviewList(all);
    for (var i = 0; i < all.length; i++) fix(all[i]);
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(run, 120);
  }

  function start() {
    run();
    /* Judge.me affiche ses avis après le chargement de la page : on suit les ajouts de contenu. */
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(run, 1500);
    setTimeout(run, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
